<template>
    <div v-cloak class="box__content" v-if="!loading">
        <div class="balance-overview__balance">
            {{currency_code}}&nbsp;<translate>Balance</translate>:
            <strong>
                <money-format :value="wallet.balance" :show_currency="show_currency" :currency_symbol="currency_symbol"></money-format>
            </strong>
        </div>
        <div class="balance-overview__pending" v-if="zqt_balance">
            ZQT&nbsp;<translate>Balance</translate>:
            <strong>
                <money-format :value="zqt_balance" :show_currency="show_currency" currency_symbol="ZQT"></money-format>
            </strong>
        </div>
        <div class="balance-overview__pending">
            <translate>Pending</translate><!--&nbsp;({{month|moment('MMMM YYYY')}})-->:
            <strong>
                <money-format :value="wallet.pending" :show_currency="show_currency" :currency_symbol="currency_symbol"></money-format>
            </strong>
        </div>
        <!--<div class="balance-overview__pending">
            <translate>Pending (next 12 months):</translate>
            <strong>
                <money-format :value="wallet.future" :show_currency="show_currency" :currency_symbol="currency_symbol"></money-format>
            </strong>
        </div>-->
    </div>
</template>
<script>
    import axios from 'axios/index';
    import MoneyFormat from "./MoneyFormat";
    import moment from "moment";
    import {EventBus} from "../event-bus";

    export default {
        name: 'my-wallet',
        components: {MoneyFormat},
        props: {
            endpoint: String,
            show_currency: {
                type: Boolean,
                default: true
            },
            currency_symbol: {
                type: String,
                default: '€'
            },
            currency_code: {
                type: String,
                default: 'EUR'
            },
            zqt_balance: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                'month': moment(),
                'interval': null,
                'loading': true,
                'wallet': {
                    'balance': 0,
                    'pending': 0,
                    'future': 0
                }
            }
        },
        methods: {
            fetchData: async function() {
                let wallet_url = process.env.VUE_APP_ZEEQUEST_URL + 'api/bbo/' + this.endpoint;
                this.wallet = (await axios.get(wallet_url)).data
                this.loading = false;
                this.$emit('loaded')
            }
        },
        created: function () {
            this.fetchData()
            let that = this;
            this.interval = setInterval(function () {
                that.fetchData()
            }, 60000),

                EventBus.$on('create_withdrawal_request', this.fetchData)

        },
        beforeDestroy() {
            clearInterval(this.interval)
            EventBus.$off('create_withdrawal_request')
        }
    }
</script>